import { Grid, Typography, useTheme } from "@mui/material"
import { AppContext } from "components/AppContextProvider"
import React, { useContext } from "react"
import { useTranslation } from "react-i18next"
import moment from "moment"

const Welcome = () => {
  const appContext = React.useContext(AppContext)
  const { t } = useTranslation()
  const { selectedLanguage } = useContext(AppContext)
  const theme = useTheme()
  const locale = selectedLanguage === "en" ? "en-gb" : selectedLanguage
  const formattedDate = moment().locale(locale).format("DD MMMM YYYY")

  return (
    <Grid item xs={12} pb={{ xs: 1, lg: 0 }}>
      <Typography variant="titleMedium" sx={{ color: theme.palette.grey[600] }}>
      <div style={{fontSize: "32px", display: "flex", flexDirection: "row", alignItems: "flex-start", flexWrap: "wrap", columnGap: "8px"}}>

       <span style={{whiteSpace: "nowrap", lineHeight: "1.4"}}>
        {t("dashboard.welcome", "Welcome")}, 
        </span> 
        <span style={{whiteSpace: "nowrap", lineHeight: "1.4"}}>
         {appContext.appUser.profile.name}!
        </span>
      </div>
      </Typography>
      <Typography mt={1} variant="bodySmall" color="textSecondary">
        {formattedDate}
      </Typography>
    </Grid>
  )
}

export default Welcome
